var _defs, _rect, _path, _path2, _path3, _rect2, _rect3, _polygon, _polygon2, _path4, _circle, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3473.29 1098.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #231f20;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 8px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #231f20;\r\n        font-family: FuturaBT-Bold, 'Futura BT';\r\n        font-size: 193.59px;\r\n        font-weight: 700;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 279.93,
    width: 123.05,
    height: 706.38
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M977.46,279.93h-37.45l-50.48,99.27-183.08,360.09h-84.51v42.64h62.84l-103.92,204.38h47.82l103.92-204.38h358.45l102.27,204.38h137.59L977.46,279.93Zm-223.18,459.36l158.98-312.67,156.46,312.67h-315.44Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1557.82,279.93V847.13c-3.3,28.81-13.9,85.1-54.82,139.18-54.83,72.45-146.15,117.17-241.62,111.62-107.98-6.28-204.31-75.9-247.92-178.68,12.98-7.88,25.95-15.75,38.93-23.63,39.02,89.95,119.92,151.11,210.06,157.16,83.34,5.6,144.24-37.94,162.18-51.83,3.38-57.1,6.77-114.2,10.15-171.3V279.93h123.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2129.86,279.93V986.31h-123.05V464.25l-209.17,260.83-209.16-264.17v-180.98h90.72l200.2,267.91c70.22-89.3,140.45-178.61,210.67-267.91h39.79Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2164.82,
    y: 279.93,
    width: 123.05,
    height: 117.44
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2164.82,
    y: 422.45,
    width: 123.05,
    height: 563.86
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "2837.44 278.67 2837.44 321.29 2649.01 321.29 2649.01 986.31 2525.96 986.31 2525.96 321.29 2339.19 321.29 2339.19 278.67 2837.44 278.67"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "3388.88 279.93 3388.88 986.31 3338.73 986.31 3338.73 787.78 3001.49 787.78 3001.49 986.31 2878.44 986.31 2878.44 787.78 2822.08 787.78 2822.08 745.14 2878.44 745.14 2878.44 279.93 3001.49 279.93 3001.49 745.14 3338.73 745.14 3338.73 279.93 3388.88 279.93"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M555.36,986.31h-67.63c-113.19-92.7-226.39-185.4-339.57-278.09v-36.46h162.24c92.71-6.54,165.5-84.36,165.89-176.94,.39-93.15-72.61-171.87-165.89-178.45H148.15v-36.46h162.24c113.9,5.8,204.23,101.25,203.83,214.91-.4,113.09-90.5,207.63-203.83,213.4h-91.67l336.63,278.09Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3353.97,
    cy: 119.32,
    r: 115.32
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3289.75 188.37)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.6873dad63ea8728947dde1bdbeb91a32.svg";
export { ForwardRef as ReactComponent };